const Logo = ({ className = "h-10 w-10" }) => {
  return (
    <svg
      viewBox="0 0 100 100"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Background glow */}
      <defs>
        <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#06b6d4" />
          <stop offset="50%" stopColor="#8b5cf6" />
          <stop offset="100%" stopColor="#06b6d4" />
        </linearGradient>
        <filter id="glow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Hexagon shape - blockchain reference */}
      <polygon
        points="50,5 90,27.5 90,72.5 50,95 10,72.5 10,27.5"
        fill="none"
        stroke="url(#logoGradient)"
        strokeWidth="2"
        filter="url(#glow)"
      />
      
      {/* Inner network nodes - blockchain/AI neural network */}
      <circle cx="50" cy="30" r="5" fill="#06b6d4" filter="url(#glow)" />
      <circle cx="30" cy="50" r="4" fill="#8b5cf6" />
      <circle cx="70" cy="50" r="4" fill="#8b5cf6" />
      <circle cx="40" cy="70" r="4" fill="#06b6d4" />
      <circle cx="60" cy="70" r="4" fill="#06b6d4" />
      <circle cx="50" cy="50" r="6" fill="url(#logoGradient)" filter="url(#glow)" />
      
      {/* Connection lines - neural network/blockchain */}
      <line x1="50" y1="30" x2="50" y2="44" stroke="#06b6d4" strokeWidth="1.5" opacity="0.7" />
      <line x1="50" y1="56" x2="40" y2="66" stroke="#8b5cf6" strokeWidth="1.5" opacity="0.7" />
      <line x1="50" y1="56" x2="60" y2="66" stroke="#8b5cf6" strokeWidth="1.5" opacity="0.7" />
      <line x1="30" y1="50" x2="44" y2="50" stroke="#06b6d4" strokeWidth="1.5" opacity="0.7" />
      <line x1="56" y1="50" x2="70" y2="50" stroke="#06b6d4" strokeWidth="1.5" opacity="0.7" />
      <line x1="50" y1="30" x2="30" y2="50" stroke="#8b5cf6" strokeWidth="1" opacity="0.5" />
      <line x1="50" y1="30" x2="70" y2="50" stroke="#8b5cf6" strokeWidth="1" opacity="0.5" />
      <line x1="40" y1="70" x2="60" y2="70" stroke="#06b6d4" strokeWidth="1" opacity="0.5" />
      
      {/* B letter stylized */}
      <text
        x="50"
        y="58"
        textAnchor="middle"
        fontFamily="Outfit, sans-serif"
        fontSize="18"
        fontWeight="bold"
        fill="white"
        opacity="0.9"
      >
        B
      </text>
    </svg>
  );
};

export default Logo;
